import {RiskModel} from "@/services/ModelRisk/RiskModel";

export class SchemaService {

    async get(modelRiskName, modelRiskVersion) {
        let response = await fetch(
            `${RiskModel.endpoint}/schema/${modelRiskName}?version=${modelRiskVersion}`
        )
        return await response.json();
    }
}
